import * as Draft from 'draft-js';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { Spacing, SpacingUnit } from 'components/ui/Spacing';
import { NewFormulaModel } from 'stores/models';
import { handleStopPropagation } from 'utils/inputEvents';

import s from './Formula.module.scss';
import { ControllersBlock, OperationsList } from './components';

type FormulaProps = {
  formulaModel: NewFormulaModel;
  /** Запрещаем вводить текст в инпуте и удалять теги при наборе формуле */
  disabled?: boolean;
  /** Скрываем операцию в случае, если мы ходим сделать формулу нередактируемой */
  hideOperations?: boolean;
};

/** Компонент для создания формулы*/
const Formula = React.forwardRef<HTMLDivElement, FormulaProps>(
  ({ formulaModel, hideOperations }) => {
    const editorRef = React.useRef<Draft.Editor | null>(null);

    React.useEffect(() => {
      formulaModel.focusToEnd();
    }, [formulaModel]);

    return (
      <div className={s.formula}>
        <Spacing className={s.formula__fields} spacing={SpacingUnit.unit3}>
          <div className={s.formula__editor} onClick={handleStopPropagation}>
            <Draft.Editor
              ref={editorRef}
              editorState={formulaModel.editorState}
              onChange={formulaModel.setEditorState}
            />
          </div>
          {!hideOperations && <OperationsList formulaModel={formulaModel} />}
        </Spacing>
        {!hideOperations && (
          <ControllersBlock
            className={s.formula__controllers}
            formulaModel={formulaModel}
          />
        )}
      </div>
    );
  }
);

Formula.displayName = 'forwardRef(Formula)';

export default observer(Formula);
